import { ReactSelectInput } from '@hivebrite/design-system/Inputs';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import useQueryOnce from 'hb-react/shared/hooks/useQueryOnce';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

interface ReactSelectUserListsProps {
  [s: string]: any;
  placeholder: string; // ReactSelectProps
}

const ReactSelectUserLists = ({
  placeholder,
  id,
  ...props
}: ReactSelectUserListsProps) => {
  const { currentNetwork } = useDefaultAppContexts();

  const { isLoading, data } = useQueryOnce({
    queryKey: ['backoffice_network_user_lists_path'],
    queryFn: () =>
      axios
        .get(
          Routes.backoffice_network_user_lists_path(currentNetwork.id, {
            per_page: 9999,
          }),
        )
        .then(({ data }) =>
          data.user_lists.map(({ id, title }) => ({
            value: id,
            label: title,
          })),
        ),
  });

  return (
    <ReactSelectInput
      {...props}
      id={id}
      name={id}
      placeholder={__('Select a user list')}
      options={data}
      isLoading={isLoading}
    />
  );
};

export default ReactSelectUserLists;
